module.exports = __webpack_public_path__ + "img/user-group-edit.21555196.svg";